import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import {useTranslation} from 'react-i18next'; 
import { Modal, Spin } from 'antd';
import { THEME } from '../../genericComponents/globalStyles';
import { CloseOutlined } from '@material-ui/icons';
import { PrymaryButton } from '../../genericComponents/Button';
import Text from '../../genericComponents/Text';

export default function PdfNameModal({isModalVisible,setIsModalVisible,pdfName,setPdfName,setPrinting,printing}){
  const { t } = useTranslation();
  const [localPrintingVariable, setLocalPrintingVariable] = useState(false)

  useEffect(() => {
    setIsModalVisible(printing);
    setLocalPrintingVariable(printing)
  }, [printing,setIsModalVisible])


  return (
    <ModalContentTotal
      visible={isModalVisible} 
      width={500}
      footer={null}
      closeIcon={localPrintingVariable?<></>:<CloseOutlined style={{color:'#FFF'}}/>}
      onCancel={()=>localPrintingVariable?null:setIsModalVisible(false)}
    >
      <ModalHeader>{t('assign_project_to_simulation')}</ModalHeader>
      <div style={{padding:'16px 40px'}}>
        <Text titleSize={1} titleLevel={1} strong>{t('project')}</Text>
        <Input value={pdfName} onChange={e=>setPdfName(e.target.value)} placeholder={t('write_the_name_of_the_project')}/>
        <Text titleLevel={1} style={{marginTop:8}}>{t('time_download_disclamer')}</Text>
      </div>
      {localPrintingVariable?
        <FooterContainer>
          <div style={{display:'flex'}}>
            <Spin />
            <Text style={{marginLeft:16}} titleSize={2} titleLevel={2} strong>{t('downloading')}...</Text>  
          </div>
        </FooterContainer>
        :
        <FooterContainer>
          <PrymaryButton secondary onClick={()=>setIsModalVisible(false)}>
            {t('cancel')}
          </PrymaryButton>
          <div style={{width:40}}/>
          <PrymaryButton disabled={!pdfName} onClick={()=>{
            if(localPrintingVariable)return
            setLocalPrintingVariable(true)
            setTimeout(() => {
              setPrinting(true);
            }, 100);
          }}>
            {t('download_simulation')}
          </PrymaryButton>
        </FooterContainer>

      }
    </ModalContentTotal>
  )
}

const ModalContentTotal = styled(Modal)`
  .ant-modal-body {
    padding: 0;
    overflow:hidden;
  }
  .ant-modal-content {
    border-radius: 12px;
  }
`;
const ModalHeader = styled.div`
  width: 100%;
  padding: 12px;
  text-align: center;
  font-size: 1.2em;;
  background-color: ${THEME.colors.blue};
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
  color: #FFF;
`;
const FooterContainer = styled.div`
  width: 100%;
  padding: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-top: solid 1px ${THEME.colors.ligthBlue};
`;
const Input = styled.input`
  width: 100%;
  ::placeholder {
    color: ${p=>p.normalPlaceholder?THEME.colors.darkBlue:THEME.colors.darkBlue+88};
    font-style: ${p=>p.normalPlaceholder?'normal':'italic'};
  }
  :focus{
    border:  2px solid ${THEME.colors.blue}55 ;
  }
`;